module.exports = __webpack_public_path__ + "img/nqr-light.787b91b7.svg";